import { render, staticRenderFns } from "./Salelist.vue?vue&type=template&id=2bcce6e9"
import script from "./Salelist.vue?vue&type=script&lang=js"
export * from "./Salelist.vue?vue&type=script&lang=js"
import style0 from "./Salelist.vue?vue&type=style&index=0&id=2bcce6e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports